<template>
  <li>
    <a
      class="text-gray-500 hover:text-gray-900 focus:text-gray-900 focus:outline-none font-normal text-sm transition-colors duration-200"
      :href="isExternal ? props.item.slug : `/${props.item.slug}`"
      :target="isExternal ? '_blank' : undefined"
      :rel="isExternal ? 'noopener noreferrer' : undefined"
      :title="item.label"
    >
      {{ item.label }}
    </a>
  </li>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const isExternal = computed(() => props.item.slug && props.item.slug.startsWith('http'));

</script>
